import React, { useCallback } from 'react';

type Props = {
  /** 选中高亮态（外部受控）：紫底紫边紫字。与智能体/技能不互斥 */
  selected?: boolean;
  /** 点击回调（仅暴露事件，业务逻辑由消费端实现） */
  onClick?: () => void;
  /** 选中态右侧 × 退出 AI生图（与编辑器内 AI生图 tag 关闭同一路径）。 */
  onExit?: () => void;
  disabled?: boolean;
};

// AI生图图标（设计稿 node 2805:30925 的矢量：图片框 + AI 星）。
// fill 用 currentColor 跟随文字色，故默认态(黑字)与选中态(紫字)各自自动着色，无需两份 SVG。
const AIImageIcon: React.FC = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M12.0699 1.36475C13.3354 1.36475 14.3603 2.39083 14.3603 3.65507V7.92055C14.3603 8.10909 14.2854 8.28992 14.152 8.42324C14.0187 8.55656 13.8379 8.63146 13.6494 8.63146C13.4608 8.63146 13.28 8.55656 13.1467 8.42324C13.0133 8.28992 12.9384 8.10909 12.9384 7.92055V3.65507C12.9384 3.42473 12.8469 3.20382 12.6841 3.04095C12.5212 2.87807 12.3003 2.78657 12.0699 2.78657H2.59111C2.36077 2.78657 2.13986 2.87807 1.97698 3.04095C1.81411 3.20382 1.72261 3.42473 1.72261 3.65507V7.68121C2.56978 6.63735 3.37666 6.10417 4.20014 6.10417C5.39447 6.10417 7.15517 7.56983 9.80806 10.5711C9.93297 10.7125 9.99659 10.8977 9.98492 11.086C9.97326 11.2743 9.88726 11.4503 9.74585 11.5752C9.67583 11.6371 9.59432 11.6845 9.50596 11.7149C9.4176 11.7452 9.32413 11.7579 9.23089 11.7521C9.04257 11.7404 8.8666 11.6544 8.74169 11.513C6.41226 8.87791 4.7902 7.52599 4.20014 7.52599C3.71198 7.52599 2.91931 8.276 1.95602 9.8329L1.72379 10.2192V12.3448C1.72379 12.8247 2.11242 13.2133 2.59229 13.2133H10.2465C10.435 13.2133 10.6158 13.2882 10.7491 13.4215C10.8825 13.5548 10.9574 13.7357 10.9574 13.9242C10.9574 14.1128 10.8825 14.2936 10.7491 14.4269C10.6158 14.5602 10.435 14.6351 10.2465 14.6351H2.59111C1.98367 14.6351 1.40112 14.3938 0.971602 13.9643C0.542083 13.5348 0.300781 12.9522 0.300781 12.3448V3.65507C0.300781 2.39083 1.32568 1.36475 2.59111 1.36475H12.0699ZM13.2074 9.58053C13.6162 9.55328 13.4242 10.5083 14.0581 11.1007C14.6908 11.6931 15.6755 11.4881 15.7003 11.9147C15.7252 12.3412 14.6956 12.269 14.16 12.827C13.6221 13.3839 13.7406 14.2145 13.301 14.2346C12.8626 14.256 13.1067 13.391 12.41 12.8081C11.7133 12.2263 10.8851 12.3886 10.8851 11.9739C10.8851 11.5592 11.7927 11.8021 12.4029 11.173C13.0131 10.5426 12.7986 9.6066 13.2086 9.58053H13.2074ZM10.0948 3.81384C10.3333 3.81384 10.5695 3.86082 10.7899 3.9521C11.0103 4.04339 11.2105 4.17718 11.3792 4.34585C11.5478 4.51451 11.6816 4.71475 11.7729 4.93512C11.8642 5.1555 11.9112 5.39169 11.9112 5.63022C11.9112 5.86875 11.8642 6.10495 11.7729 6.32532C11.6816 6.5457 11.5478 6.74593 11.3792 6.9146C11.2105 7.08327 11.0103 7.21706 10.7899 7.30834C10.5695 7.39962 10.3333 7.44661 10.0948 7.44661C9.61306 7.44661 9.15105 7.25524 8.81041 6.9146C8.46978 6.57396 8.27841 6.11196 8.27841 5.63022C8.27841 5.14849 8.46978 4.68648 8.81041 4.34585C9.15105 4.00521 9.61306 3.81384 10.0948 3.81384ZM10.0948 5.0769C10.0221 5.0769 9.95017 5.09121 9.88304 5.11902C9.81591 5.14682 9.75491 5.18758 9.70353 5.23896C9.65215 5.29034 9.61139 5.35134 9.58358 5.41847C9.55578 5.48561 9.54146 5.55756 9.54146 5.63022C9.54146 5.70289 9.55578 5.77484 9.58358 5.84197C9.61139 5.90911 9.65215 5.9701 9.70353 6.02148C9.75491 6.07287 9.81591 6.11362 9.88304 6.14143C9.95017 6.16924 10.0221 6.18355 10.0948 6.18355C10.2415 6.18355 10.3823 6.12525 10.4861 6.02148C10.5898 5.91772 10.6481 5.77697 10.6481 5.63022C10.6481 5.48347 10.5898 5.34273 10.4861 5.23896C10.3823 5.13519 10.2415 5.0769 10.0948 5.0769Z"
      fill="currentColor"
    />
  </svg>
);

/** footer「AI生图」按钮：与智能体/技能同款外观，仅视觉 + 点击回调（无下拉面板）。
 *  选中态 selected 由外部受控；与智能体/技能不互斥。 */
export const AIImageButton: React.FC<Props> = React.memo(({ selected, onClick, onExit, disabled }) => {
  const handleClick = useCallback((event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation();
    if (disabled) return;
    onClick?.();
  }, [disabled, onClick]);

  const badgeClass = `rte-ai-image-badge${selected ? ' rte-ai-image-badge-selected' : ''}`;

  return (
    <div
      className={badgeClass}
      onClick={handleClick}
      data-rte-ai-image-button="true"
      aria-pressed={!!selected}
      style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
    >
      <AIImageIcon />
      <span className="rte-ai-image-text">AI生图</span>
      {/* 选中态右侧 × 退出 AI生图。stopPropagation 防止冒泡触发 handleClick 又进入 AI生图。 */}
      {selected && onExit && (
        <i
          className="iconfont icon-guanbi rte-tool-close"
          role="button"
          aria-label="退出 AI 生图"
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (disabled) return;
            onExit();
          }}
        />
      )}
    </div>
  );
});
AIImageButton.displayName = 'AIImageButton';
